import _ from 'lodash';

import {createStore} from '../alt';

import NotificationActions from '../actions/NotificationActions';


class NotificationStore {
    constructor() {
        this.notifications = {};

        this.bindActions(NotificationActions);
    }

    __showLevel(data) {
        const cfgBase = _.extend({
            level: 'info',
            autoDismiss: 5,
            dismissible: false,
            action: false
        }, data);

        this.notifications[data.uuid] = NotificationStore.makeNotificationConfig(cfgBase, data.uuid);
    }

    onShowLoader(data) {
        const cfgBase = _.extend({
            level: 'info',
            autoDismiss: 0,
            dismissible: false,
            action: false,
            loader: true
        }, data);

        this.notifications[data.uuid] = NotificationStore.makeNotificationConfig(cfgBase, data.uuid);
    }

    onHideNotification(notification) {
        this.__removeNotification({uid: notification.uuid});
    }

    hideNotifications(patterns) {
        if (patterns.startsWith) {
            Object.keys(this.notifications).forEach(uuid => {
                if (uuid.startsWith(patterns.startsWith)) {
                    this.__removeNotification({uid: uuid});
                }
            });
        }
    }

    __removeNotification(notification) {
        if (this.notifications[notification.uid]) {
            delete this.notifications[notification.uid];
        }
    }

    static makeNotificationConfig(cfg, uuid) {
        return _.extend({
            uid: uuid,
            message: 'No message provided...',
            level: 'success',
            position: 'tr',
            autoDismiss: 5,
            dismissible: true,
            allowHTML: false
        }, cfg, {
            onRemove: NotificationActions.__removeNotification
        });
    }
}


export default createStore(NotificationStore, 'NotificationStore', module);



/** WEBPACK FOOTER **
 ** ./app/src/stores/NotificationStore.js
 **/